import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { addFundChartCorrelation, removeFundChartCorrelation, setFundChartCorrelations, toggleFundChartCorrelation, updateFundChartCorrelation, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/correlations/correlations.actions';
export const correlations = createReducer([], on(setChartData, (state, { chartData }) => {
    const cleanedCorrelationIds = chartData.params.correlations.map((correlation) => correlation.correlationId);
    // Validate against id only so non-fixed correlations (i.e. _firstSecurity_, _listSecurity_) persist in state
    return state ? state.filter((correlation) => cleanedCorrelationIds.includes(correlation.correlationId)) : [];
}), on(addFundChartCorrelation, (state, { correlation }) => {
    return [...state, correlation];
}), on(toggleFundChartCorrelation, (state, { correlationIndex }) => {
    return state.map((correlation, index) => {
        if (index === correlationIndex) {
            const include = !correlation.include;
            return { ...correlation, include };
        }
        return correlation;
    });
}), on(updateFundChartCorrelation, (state, { correlation, correlationIndex }) => {
    return state.map((_correlation, index) => (index === correlationIndex ? correlation : _correlation));
}), on(removeFundChartCorrelation, (state, { correlationIndex }) => {
    return state.filter((correlation, index) => index !== correlationIndex);
}), on(setFundChartCorrelations, (state, { correlations: newCorrelations }) => {
    return newCorrelations.filter((correlation) => correlation !== undefined);
}));
